export default __webpack_public_path__ + "static/media/logo_whatsapp.71b6c081.svg";